var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab"},[_c(_vm.component,{tag:"component",attrs:{"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }